<template>
    <div>
        <app-sub-title text="Filtros" />
        <div class="d-flex align-items-center">
            <div class="px-2">
                <app-form-select-input 
                    v-model="filters.menu"
                    placeholder="Menú"
                    :options="menus"
                />
            </div>
            <div class="px-2">
                <app-form-text-input 
                    v-model="filters.nameMenuOption"
                    placeholder="Opción"
                />
            </div>
            <div class="px-2">
                <b-button variant="primary" @click="$emit('filter', filters)"><i class="fa fa-filter"></i></b-button>
            </div>
            <div class="px-2">
                <b-button variant="secondary" @click="clearFilters"><i class="fa fa-times-circle"></i></b-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        menus: {
            type: Array
        }
    },
    data(){
        return {
            filters: {
                nameMenuOption: '',
                menu: ''
            }
        }
    },
    methods: {
        clearFilters(){
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', null);
        }
    }
}
</script>
